(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retinol-ritual-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retinol-ritual-video')) {
    class RetinolRitualVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.addEventListener('pointerenter', () => this.video.play().catch(() => {}));
        this.addEventListener('pointerleave', () => this.video.pause());
        this.addEventListener('focusin', () => this.video.play().catch(() => {}));
        this.addEventListener('focusout', () => this.video.pause());
      }
    }
    customElements.define('retinol-ritual-video', RetinolRitualVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
